import ListeTypeTaxePage from "@/pages/GesCom/TypeTaxe/ListeTypeTaxePage.vue";

interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    children?: MenuItem[];
    bookmark?: boolean;
    role?: string;
}

export const menu: MenuItem[] = [
    {
        path: "/accueil/tableau-bord",
        title: "Tableau de bord",
        type: "link",
        icon: "stroke-home",
        icon1: "fill-home",
        active: false,
        isPinned: false,
        role: "DashBord"
    },


    {
        headTitle1: "Gestion des inventaires",
        headTitle2: "Gestion des inventaires",
        type: "headtitle",
        //role: "ListProduit"
        role: "ListProduit|ListFamille|ListConditionnement|ListMagasin|AddMouvement|EtatInventaire|ListMouvement"
    },
    {
        title: "Gestion des produits",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit",
        children: [
            {
                path: "/produits/liste-produits",
                title: " produits",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListProduit"
            },
            {
                path: "/familles/liste-familles",
                title: "familles",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListFamille"
            },
            {
                path: "/conditionnements/liste-conditionnements",
                title: "conditionnements",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListConditionnement"
            },

            // {
            //     path: "/marques/liste-marques",
            //     title: "Liste des marques",
            //     type: "link",
            //     icon: "stroke-learning",
            //     icon1: "fill-learning",
            //     isPinned: false,
            //     role: "ListMarque"
            // },

        ]
    },

    {
        title: "Gestion des inventaires",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListConditionnement|ListMotifSuivi|ListMagasin|ListPointVente|ListMarque",

        children: [
            {
                path: "/inventaires/liste-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des inventaires",
                isPinned: false,
                type: "link",
                role: "ListInventaire"
            },

            {
                path: "/inventaires/liste-fiche-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des fiches d'inventaires",
                isPinned: false,
                type: "link",
                role: "ListeFicheProduit"
            },

            {
                path: "/inventaires/ajouter-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Créer une fiche d'inventaire",
                isPinned: false,
                type: "link",
                role: "ListProduit"
            },
            {
                path: "/inventaires/inventorier",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Inventorier",
                isPinned: false,
                type: "link",
                role: "EditInventaire"
            },
            {
                path: "/inventaires/ajouter-mouvement",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Mouvement",
                isPinned: false,
                type: "link",
                role: "AddMouvement"
            },
            {
                path: "/inventaires/liste-produit-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Etats inventaire",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },
            {
                path: "/inventaires/liste-mouvements",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des mouvements",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },


        ]
    },


    {
        title: "Gestion des fiches",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListInventaire|AddMouvementFiche|ListeFicheProduit|ListeControlFiche",
        children: [
            {
                path: "/inventaires/ajouter-mouvement-fiche",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Ajouter un mouvement de fiche",
                isPinned: false,
                type: "link",
                role: "AddMouvementFiche"
            },
            {
                path: "/inventaires/liste-mouvements-fiche",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des mouvements des fiches",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },
            {
                path: "/fiches/liste-fiches",
                title: "Fiches de stock",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeFicheProduit"
            },
            {
                path: "/controls/liste-controls",
                title: "Controle fiche",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeControlFiche"
            },



        ]
    },

    {
        title: "Gestion des Clients",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeClient|ListeContrat|AddContrat|ListCompte|AddCompte|AddClient|ListeMesClients",
        children: [
            {
                path: "/clients/liste-clients",
                title: "Clients",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClient"
            },
            {
                path: "/categorieclients/liste-categorieclients",
                title: " categorie clients",
                type: "link",
            },

            {
                path: "/comptes/liste-comptes",
                title: "Comptes clients",
                type: "link",
                role: "ListCompte"
            },
            {
                path: "/contrats/liste-contrats",
                title: "Contrat client",
                type: "link",
                role: "ListContrat"
            },


            {
                path: "/mesclients/liste-mesclients",
                title: "Mes clients",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeMesClients"
            },

        ]
    },

    /*{
        title: "Gestion des comptes",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeCompte|AddCompte",
        children: [
            {
                path: "/comptes/ajouter-compte",
                title: "Ajouter un compte",
                type: "link",
                role: "AddCompte"
            },
            {
                path: "/comptes/liste-comptes",
                title: "Liste des comptes",
                type: "link",
                role: "ListCompte"
            },

        ]
    },
    {
        title: "Gestion des contrats",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeContrat|AddContrat",
        children: [
            {
                path: "/contrats/ajouter-contrat",
                title: "Ajouter un contrat",
                type: "link",
                role: "AddContrat"
            },
            {
                path: "/contrats/liste-contrats",
                title: "Liste des contrats",
                type: "link",
                role: "ListContrat"
            },

        ]
    },*/
    {
        title: "Gestion des commandes fournisseurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListCommandesFournisseurs | AddCommandeFournisseur",
        children: [
            {
                path: "/commandesfournisseurs/listes-commandesfournisseurs",
                title: "Liste des commandes fournisseurs",
                type: "link",
                role: "ListCommandesFournisseurs"
            },
            {
                path: "/commandesfournisseurs/ajouter-commandefournisseur",
                title: "Ajouter une commande fournisseur",
                type: "link",
                role: "AddCommandeFournisseur"
            }
        ]
    },
    {
        title: "Gestion des bons",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeBonLivraison|AddBonLivraison|AddBonCommandeFournisseur|AddBonRetour|AddDemandePrix|ListeBonRetour|ListeBonCommandeFournisseur|",
        children: [
            {
                path: "/bons/ajouter-bonLivraison",
                title: "Ajouter un bon",
                type: "link",
                role: "AddBonLivraison"
            },
            {
                path: "/bons/liste-bonLivraison",
                title: "Liste des bons",
                type: "link",
                role: "ListeBonLivraison"
            },
             {
                path: "/bons/ajouter-bonAncien",
                title: "Ajouter un ancien bon",
                type: "link",
                role: "AddBonLivraison"
            },
            {
                path: "/bons/liste-bonAncien",
                title: "Liste des anciens bons",
                type: "link",
                role: "ListeBonLivraison"
            },
            {
                path: "/bonretour/ajouter-bonRetour",
                title: "Bon de retour",
                type: "link",
                role: "AddBonRetour"
            },
            {
                path: "/bonretour/liste-bonRetour",
                title: "Liste des bons de retour",
                type: "link",
                role: "ListeBonRetour"
            },
            {
                path: "/bons-commandefournisseurs/ajouter-boncommandefournisseur",
                title: "Commandes fournisseurs",
                type: "link",
                role: "AddBonCommandeFournisseur"
            },
            {
                path: "/bons-commandefournisseurs/liste-commandefournisseurs",
                title: "Liste des commandes fournisseurs",
                type: "link",
                role: "ListeBonCommandeFournisseur"
            },
            {
                path: "/demandes-prix/liste-demande-prix",
                title: " Demandes de prix",
                type: "link",
                role: "AddDemandePrix"
            },

        ]
    },
    {
        title: "Gestion des créances",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListCreance|AddCreance|ListEcheance|ListReglement|ListRapportRelance|ListDepot|AddDepot|AddRapportRelance|AddReglement",
        //role: "ListMagasin",
        children: [
            // {
            //     path: "/creances/ajouter-creance",
            //     title: "Ajouter une créance",
            //     type: "link",
            //     role: "AddCreance"
            //     // role: "ListMagasin"
            // },
            {
                path: "/creances/liste-creances",
                title: "Liste des créances",
                type: "link",
                role: "ListCreance"
            },
            {
                path: "/echeances/liste-echeances",
                title: "Liste des échéances",
                type: "link",
                role: "ListEcheance"
            },
            {
                path: "/depots/liste-depots",
                title: "Dépôts d'argent",
                role: "ListDepot",
                type: "link"

            },
            {
                path: "/rapportRelances/liste-rapportRelance",
                title: "Rapports de relance",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListRapportRelance"
            },
            {
                path: "/reglements/liste-reglements",
                title: "Règlements",
                type: "link",
                role: "ListReglement"
            },

        ]
    },

    // {
    //     title: "Gestion des échéances",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     role: "AddEcheance|ListEcheance",
    //     //role: "ListMagasin",
    //     children: [
    //         // {
    //         //     path: "/echeance/ajouter-echeance",
    //         //     title: "Ajouter une échéance",
    //         //     type: "link",
    //         //     role: "AddEcheance"
    //         //     // role: "ListMagasin"
    //         // },

    //         {
    //             path: "/echeances/liste-echeances",
    //             title: "Liste des échéances",
    //             type: "link",
    //             role: "ListEcheance"
    //            //role: "ListEcheance"
    //         },
    //     ]
    // },

    // {
    //     title: "Gestion des règlements",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,

    //     role: "ListReglement|AddReglement",
    //     children: [
    //         {
    //             path: "/reglements/ajouter-reglement",
    //             title: "Ajouter un règlement",
    //             type: "link",

    //             role: "AddReglement"
    //         },
    //         {
    //             path: "/reglements/liste-reglements",
    //             title: "Liste des règlements",
    //             type: "link",

    //             role: "ListReglement"
    //         },
    //     ]
    // },

    {
        title: "Fournisseurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListFournisseur|AddFournisseur",
        children: [
            {
                path: "/fournisseurs/ajouter-fournisseur",
                title: "Ajouter un fournisseur",
                role: "AddFournisseur",
                type: "link"
            },
            {
                path: "/fournisseurs/liste-fournisseurs",
                title: "Liste des fournisseurs",
                role: "ListFournisseur",
                type: "link"
            },
        ]
    },


    {
        title: "Vente",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/ventes/ajouter-vente",
                title: "Ajouter une vente",
                type: "link"
            },
            {
                path: "/ventes/liste-ventes",
                title: "Liste des ventes",
                type: "link"
            },
            // {
            //     path: "/demandes-commande/liste-demandes-commande",
            //     title: "Demandes de commande",
            //     type: "link"
            // },
        ]
    },

    {
        title: "Etats",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/etats/produits-disponibles",
                title: "stock actuelle",
                type: "link"
            },
            // {
            //     path: "/etats/produits-vendus",
            //     title: "Liste des produits vendus",
            //     type: "link"
            // },
            {
                path: "/etats/produits-livres",
                title: "Liste des produits livres",
                type: "link"
            },
            {
                path: "/etats/produits-rupture",
                title: "Liste des produits en rupture de stock",
                type: "link"
            },
            {
                path: "/etats/point-commande",
                title: "Liste du point des commandes",
                type: "link"
            },
            {
                path: "/etats/etat-produits-entree",
                title: "Liste des produits entrées",
                type: "link"
            },
            {
                path: "/etats/etats-produits-sorties",
                title: "Liste des produits sorties",
                type: "link"
            },
            {
                path: "/etats/etat-nmbre-pro",
                title: 'Nombre du produits vendus par période',
                type: "link"
            },
            {
                path: "/etats/ca-client",
                title: `Chiffre d'affaire par client`,
                type: "link"
            },
            // {
            //     path: "/etats/commandes-par-utilisateur",
            //     title: `Nombre des commandes par utilisateur`,
            //     type: "link"
            // }
        ]
    },

    {
        title: "Opérations",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/detachements/liste-detachements",
                title: "Liste des detachements",
                type: "link"
            },
            {
                path: "/sorties/liste-sorties",
                title: "Liste des sorties",
                type: "link"
            },
            {
                path: "/transferts/liste-transferts",
                title: "Liste des transferts par point de vente",
                type: "link"
            },
            {
                path: "/transferts/liste-transfertMag",
                title: "Liste des transferts par magasin ",
                type: "link"
            },
            {
                path: "/approvisionnements/liste-approvisionnements",
                title: "Liste des approvisionnements",
                type: "link"
            },
            {
                path: "/livraisons/liste-livraisons",
                title: "Liste des livraisons",
                type: "link"
            },
        ]
    },

    {
        title: "Caisse",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/caisses/liste-caisses",
                title: "Liste des caisses",
                type: "link"
            },

            // {
            //     path: "/depenses/liste-depenses",
            //     title: "Liste des dépenses",
            //     type: "link"
            // },
            // {
            //     path: "/depots/liste-depots",
            //     title: "Liste des dépôts",
            //     type: "link"
            // },

            {
                path: "/OuverturesFermetures",
                title: "Liste des caisses ouvertes et fermées",
                type: "link"
            },

        ]
    },

    {
        title: "Monnaies",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/monnaies/liste-monnaies",
                title: "Liste des monnaies",
                type: "link"
            },

        ]
    },

    {
        title: "Société",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/societes/liste-societes",
                title: "sociétés",
                type: "link"
            },

        ]
    },



    {

        title: "Facture",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/factures/liste-factures",
                title: " factures",
                type: "link"
            },


        ]
    },

    // {
    //     title: "Gestion des dépots",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     role: "ListDepot|AddDepot",
    //     children: [
    //         {
    //             path: "/depots/ajouter-depot",
    //             title: "Ajouter un dépôt",
    //             role: "AddDepot",
    //             type: "link"

    //         },
    //         {
    //             path: "/depots/liste-depots",
    //             title: "Liste des dépôts",
    //             role: "ListDepot",
    //             type: "link"

    //         },

    //     ]
    // },

    // {
    //     title: "Gestion des transactions",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //    role: "ListTransaction|AddTransaction",
    //     children: [
    //         // {
    //         //     path: "/transactions/ajouter-transaction",
    //         //     title: "Ajouter une transaction",
    //         //     //role: "AddTransaction",
    //         //     role:"ListMagasin",
    //         //     type: "link"
    //         // },
    //         {
    //             path: "/transactions/liste-transactions",
    //             title: "Liste des transactions",
    //             role: "ListTransaction",
    //             type: "link"

    //         },

    //     ]
    // },
    
      {
        title: "Trésorerie",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListCompteEntreprise",
        children: [
            
            {
                path: "/comptesentreprises/liste-comptes-entreprises",
                title: "Liste des trésoreries",
                type: "link",
                role: "ListCompteEntreprise"
            },

        ]
    },
     
 /* 
     {
        title: "Mes clients",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeClientAffecters",
        children: [
            {
                path: "/clientAffecter/liste-clientAffecter",
                title: "Liste des clients affectés",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClientAffecters"
            },
        ]
    },*/

    //  {
    //     title: "Gestion des rapports",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     //role: "ListeClient",
    //     role: "AddRapportRelance|ListRapportRelance",
    //     children: [
    //         {
    //             path: "/rapportRelances/ajouter-rapportRelance",
    //             title: "Ajouter un rapport",
    //             type: "link",
    //             icon: "stroke-learning",
    //             icon1: "fill-learning",
    //             isPinned: false,
    //             role: "AddRapportRelance"
    //         },
    //         {
    //             path: "/rapportRelances/liste-rapportRelance",
    //             title: "Liste des rapports",
    //             type: "link",
    //             icon: "stroke-learning",
    //             icon1: "fill-learning",
    //             isPinned: false,
    //             role: "ListRapportRelance"
    //         },
    //     ]
    // },

    {
        title: "Paramètres",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListeFamilleProduitChampsLibres|AddFamilleProduitChampsLibres|ListConditionnement|ListMotifSuivi|ListMagasin|ListPointVente|AddChampsLibre|AddClient|ListClient|ListMarque|ListeCodification|ListDomaineActivite|ListTaxe|ListTypeTaxe|ListModeRegelement|ListPiece|ListBanque|ListCompteEntreprise|ListeClientAffecters",
        children: [

            {
                path: "/motifSuivis/liste-motifSuivi",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "MotifSuivi",
                isPinned: false,
                type: "link",
                role: "ListMotifSuivi"

            },
            {
                path: "/codifications/liste-codifications",
                title: "codifications",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeCodification"
            },
            {
                path: "/pieces/liste-pieces",
                title: "pieces",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                type: "link",
                role: "ListPiece"
            },
            {
                path: "/magasins/liste-magasins",
                title: "magasins",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                type: "link",
                role: "ListMagasin"
            },
            {
                path: "/domaines/liste-domaines",
                title: "domaines",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                type: "link",
                role: "ListDomaineActivite"
            },
            {
                path: "/point-ventes/liste-point-ventes",
                title: "points de vente",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListPointVente"
            },
            {
                path: "/liste-groupe-taxes",
                title: "groupe de taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
            },
            {
                path: "/liste-taxes",
                title: "Taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListTaxe"
            },
            {
                path: "/banques/liste-banques",
                title: "banques",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListBanque"
            },
             {
                path: "/configurations/liste-configurations",
                title: "ListeConfiguration",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                // role: "ListBanque"
            },

            // {
            //     path: "/type-comptes/liste-typecompte",
            //     title: "types de compte",
            //     type: "link"
            // },
            // {
            //     path: "/transactions/liste-transactions",
            //     title: "Liste des transactions",
            //     type: "link"
            // },

            {
                path: "/personnelles/liste-personnel",
                title: "personnels",
                type: "link"
            },

            {
                path: "/modele-signataires/liste-modele-signataires",
                title: "modèles de signataires",
                type: "link"
            },

            {
                path: "/liste-type-taxes",
                title: "Type de taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListTypeTaxe"
            },

            {
                path: "/fonctions/liste-fonctions",
                title: "Fonction",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                // role: "ListModeReglement"
            },
            {
                path: "/typeDocuments/liste-typeDocuments",
                title: "TypeDocument",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                // role: "ListModeReglement"
            },


            {
                path: "/mode-reglements/liste-mode-reglements",
                title: "Modes de règlement",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListModeReglement"
            },
            {

                path: "/comptesentreprises/liste-comptes-entreprises",
                title: "Trésorerie",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListCompteEntreprise"
            },
            {
                path: "/clientAffecter/liste-clientAffecter",
                title: "Les affectations",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClientAffecters"
            },

            {
                title: "Champs Descriptifs",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListeChampsLibre",
                children: [
                    {
                        path: "/champsLibres/ajouter-champsLibre",
                        title: "Ajouter un champ",
                        type: "link",
                        role: "AddChampsLibre"
                    },
                    {
                        path: "/champsLibres/liste-champsLibre",
                        title: "Liste des champs",
                        type: "link",
                        role: "ListeChampsLibre"
                    },

                ]
            },
            {
                title: "Champs Affectés",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListeFamilleProduitChampsLibres",
                children: [
                    {
                        path: "/champsLibreFamille/ajouter-champsLibreFamille",
                        title: "Affecter un champ",
                        type: "link",
                        role: "AddFamilleProduitChampsLibres"
                    },

                    {
                        path: "/champsLibreFamille/liste-champsLibreFamille",
                        title: "Liste des champs affectés",
                        type: "link",
                        role: "ListeFamilleProduitChampsLibres"
                    },
                ]

            },


        ]
    },


    {
        headTitle1: "Gestion des utilisateurs",
        headTitle2: "Utilisateurs, Rôles et permissions",
        type: "headtitle",
        role: "AddUser|ListUser|AddRole|ListRole|ListPermission"
    },

    {
        title: "Gestion des utilisateurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListUser",
        children: [

            {
                title: "Utilisateurs",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListUser",
                children: [
                    {
                        path: "/utilisateurs/ajouter-utilisateur",
                        title: "Ajouter un utilisateur",
                        type: "link",
                        role: "AddUser"
                    },
                    {
                        path: "/utilisateurs/liste-utilisateur",
                        title: "Liste des utilisateurs",
                        type: "link",
                        role: "ListUser"
                    },
                ]
            },
            {
                title: "Role",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListRole",
                children: [
                    {
                        path: "/roles/ajouter-role",
                        title: "Ajouter un rôle",
                        type: "link",
                        role: "AddRole"
                    },
                    {
                        path: "/roles/liste-role",
                        title: "Liste des rôles",
                        type: "link",
                        role: "ListRole"
                    },
                ]
            },
            {
                title: "Permissions",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListPermission",
                children: [
                    {
                        path: "/permissions/liste-permission",
                        title: "Liste des permissions",
                        type: "link",
                        role: "ListPermission"
                    },

                ]
            },


        ]
    },
]


